export const NONLOGIN_PATHS = [
  '/login',
  '/logout',
  '/error',
  '/forbidden',
  '/404',
  '/',
]
